import { create, read, update } from '@/api/rest';

const projectTeamRequest = {
  all: async (params) =>
    await read(`/project-team-request?${params.toString()}`),
  approve: async (id) => await update(`/project-team-request/approve/${id}`),
  create: async (data) => await create('/project-team-request-public', data),
  reject: async (id) => await update(`/project-team-request/reject/${id}`),
  count: async (params) =>
    await read(`/project-team-request/count?${params.toString()}`),
};

export default projectTeamRequest;
